import React from "react";
import { connect } from "react-redux";
import { TReducers } from "@features/reducers";
import { IWalletDetails } from "@market/interfaces/IWallet";
import Stats from "./parts/Stats/Stats";
import RewardsTable from "./parts/RewardsTable/RewardsTable";
import Loader from "@appComponents/Loader/Loader";
import { RouteComponentProps } from "react-router-dom";
import { TUserAgreements } from "@features/reducer.info";

import * as style from "./DashboardStyle.module.scss";
import { FaqSection } from "./parts/FaqSection";

type Props = {
  currency: string;
  selectedWallet?: IWalletDetails | undefined;
  appLink: string;
  investorId?: number;
  country?: string;
  agreements?: TUserAgreements;
  history: RouteComponentProps<{}>["history"];
  location: RouteComponentProps<{}>["location"];
  tier?: string;
  canStake?: boolean;
  timelockBalance?: number;
  investorSlug?: string;
};

type StakingStatus = "empty" | "staked" | "processing" | "queued";

export type StakeWallet = Array<{
  amount: string;
  created_at: string;
  total_usd: string;
  id: number;
  status: StakingStatus;
}>;

const Dashboard = ({
  appLink,
  investorId,
  country,
  agreements,
  history,
  location,
  tier,
  canStake,
  timelockBalance,
  investorSlug,
}: Props) => {
  if (investorId) {
    return (
      <div className={style.dashboard}>
        <Stats
          location={location}
          history={history}
          investorCountry={country}
          appLink={appLink}
          tier={tier}
          investorId={investorId}
          investorAgreements={agreements}
          canStake={canStake}
          timelockBalance={timelockBalance}
          investorSlug={investorSlug}
        />
        <RewardsTable investorId={investorId} />
        <FaqSection />
      </div>
    );
  }

  return <Loader />;
};

const mapStateToProps = (store: TReducers, ownProps: Props) => ({
  investorId: store.userInfo.investor_id,
  country: store.userInfo.country,
  agreements: store.userInfo.agreements,
  tier: store.userInfo.tier,
  selectedWallet: store.fundsReducer.supportedUserWallets?.find(
    (wallet) => wallet.currency === ownProps.currency
  ),
  canStake: store.userInfo.can_stake,
  timelockBalance: store.userInfo.timelock_balance,
  investorSlug: store.userInfo.nickname,
});

export default connect(mapStateToProps)(Dashboard);
